import { render, staticRenderFns } from "./MajPrestijMasse.vue?vue&type=template&id=070d1c73"
import script from "./MajPrestijMasse.vue?vue&type=script&lang=js"
export * from "./MajPrestijMasse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports